import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ResourceTableBody from '@presentational/ResourceTableBody';
import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import { ta } from 'utils';

const propTypes = {
  groupedItems: PropTypes.arrayOf(PropTypes.shape({
    records: PropTypes.array.isRequired, // sale items
    transfer: PropTypes.object.isRequired,
    total_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    total_amount_formatted: PropTypes.string.isRequired,
  })),
}

const defaultProps = {

}

const saleReportItemsCols = [
  { size: 2, header: "ID", accessor: "bright_pearl_order_id" },
  { size: 2, header: ta("sale_report_item.order_date"), accessor: "order_date_human" },
  { size: 2, header: ta("products_transfer.variant_sku"), accessor: "sku" },
  { size: 2, header: ta("general.quantity"), accessor: "quantity" },
  { size: 2, header: "Costo", accessor: (record) => `${record.total_cost_formatted}` },
  { size: 2, header: "Costo + IVA", accessor: (record) => `${record.total_amount_formatted}` },
];

const SalesByTransfers = (props) => {
  return (
    <div>
      <ResourceTableHeaders
        columnsInfo={saleReportItemsCols}
      />
      { props.groupedItems.map( ({records, transfer, total_amount_formatted}, index)  =>
        <div key={index}>
          <ResourceTableBody
            columnsInfo={saleReportItemsCols}
            items={ records }
            itemURL={null}
          />
          <div className="container-fluid pv15 bg-gray mb40">
            <div className="row">

              <div className="col-md-10">
                Total por abonar a factura <strong>{transfer.invoice_number}</strong>, ingresada en Entrega APU <strong>{transfer.name} { transfer.vendor }</strong>
              </div>
              <div className="col-md-2">
                { total_amount_formatted }
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  )
};

SalesByTransfers.propTypes = propTypes;
SalesByTransfers.defaultProps = defaultProps;

export default SalesByTransfers;